<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Cuotas Plantas</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Cuotas Plantas</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="form">
        <div class="container-fluid">
            <div class="row align-items-center">

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field *ngIf="companiaSeleccionada != null" class="readonly-form-field"
                        color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Compania}}</mat-label>

                        <input readonly [value]="companiaSeleccionada.id + ' - ' + companiaSeleccionada.descripcion"
                            type="text" matInput>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field *ngIf="salesOrgSeleccionada != null" class="readonly-form-field"
                        color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.SalesOrg}}</mat-label>

                        <input readonly [value]="salesOrgSeleccionada.id + ' - ' + salesOrgSeleccionada.descripcion"
                            type="text" matInput>
                    </mat-form-field>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <mat-form-field *ngIf="!c" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdProducto}}</mat-label>
                        <input (change)="handleEmptyInputProducto($event)" matInput [matAutocomplete]="autoProducto"
                            [formControl]="fcAutocompleteProducto" placeholder="Código, descripción, etc..">
                        <button type="button" matSuffix mat-icon-button (click)="limpiarProducto(true)"
                            matTooltip="Limpiar producto seleccionado">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-autocomplete #autoProducto="matAutocomplete"
                            (optionSelected)='seleccionarProducto($event.option.value)'
                            [displayWith]="getOptionTextProducto">
                            <mat-option *ngIf="loadingFcAutocompleteProducto"
                                class="is-loading">Cargando...</mat-option>
                            <ng-container *ngIf="!loadingFcAutocompleteProducto">
                                <mat-option *ngFor="let p of productosEncontrados" [value]="p">
                                    {{p.displayValue}}
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>

                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdProducto}}</mat-label>
                        <input *ngIf="productoSeleccionado == null" readonly [value]="" type="text" matInput>
                        <input *ngIf="productoSeleccionado != null" readonly [value]="productoSeleccionado.id"
                            type="text" matInput>
                    </mat-form-field>
                </div>


                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Producto}}</mat-label>
                        <input *ngIf="productoSeleccionado == null" readonly [value]="" type="text" matInput>
                        <input *ngIf="productoSeleccionado != null" readonly [value]="productoSeleccionado.descripcion"
                            type="text" matInput>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline" *ngIf="!c">
                        <mat-label>{{Etiquetas.IdPlanta}}</mat-label>
                        <mat-select (selectionChange)="seleccionarPlanta($event.value)" [compareWith]="comparePlantas"
                            formControlName="idPlanta">
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let p of plantas" [value]="p.idPlanta">{{p.displayValue}}
                            </mat-option>
                        </mat-select>

                        <mat-error *ngIf="(form.get('idPlanta').hasError('required')) && form.get('idPlanta').touched ">
                            {{Validaciones.IdPlanta}}
                        </mat-error>

                    </mat-form-field>
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                        *ngIf="c">
                        <mat-label>{{Etiquetas.IdPlanta}}</mat-label>
                        <input readonly [value]="c.idPlanta" type="text" matInput>

                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline" *ngIf="!c">
                        <mat-label>{{Etiquetas.IdUbicacionAlmacenamiento}}</mat-label>
                        <mat-select (selectionChange)='seleccionarStorageLocation($event.value)'
                            [compareWith]="compareStoragesLocations" formControlName="idUbicacionAlmacenamiento">
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let u of ubicacionesAlmacenamientos" [value]="u.id">{{u.id}}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="(form.get('idUbicacionAlmacenamiento').hasError('required')) && form.get('idUbicacionAlmacenamiento').touched">
                            {{Validaciones.StorageLocation}}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                        *ngIf="c">
                        <mat-label>{{Etiquetas.IdUbicacionAlmacenamiento}}</mat-label>
                        <input readonly [value]="c.idUbicacionAlmacenamiento" type="text" matInput>

                    </mat-form-field>
                </div>


                <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.MesyAnio}}</mat-label>
                        <input readonly matInput [matDatepicker]="dp2" [min]="sixMonthsAgo" [max]="years" (click)="openDatePicker(dp2)" formControlName="mesyAnio">
                        
                        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                        <mat-datepicker #dp2 startView="multi-year" (monthSelected)="closeDatePicker($event, dp2)"></mat-datepicker>

                        <mat-error
                        *ngIf="(form.get('mesyAnio').hasError('required')) && form.get('mesyAnio').touched ">
                        {{Validaciones.MesyAnio}}
                    </mat-error>
                    
                      </mat-form-field>

 
                </div> -->

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline" *ngIf="!c">
                        <mat-label>{{Etiquetas.Anio}}</mat-label>
                        <mat-select [compareWith]="compareAnios" formControlName="anio">
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let a of anios" [value]="a">{{a}}
                            </mat-option>
                        </mat-select>

                        <mat-error *ngIf="(form.get('anio').hasError('required')) && form.get('anio').touched ">
                            {{Validaciones.Anio}}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                    *ngIf="c">
                    <mat-label>{{Etiquetas.Anio}}</mat-label>
                    <input readonly [value]="c.anio" type="text" matInput>

                </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline" *ngIf="!c">
                        <mat-label>{{Etiquetas.Mes}}</mat-label>
                        <mat-select [compareWith]="compareMeses" formControlName="mes">
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let m of meses" [value]="m">{{m}}
                            </mat-option>
                        </mat-select>

                        <mat-error *ngIf="(form.get('mes').hasError('required')) && form.get('mes').touched ">
                            {{Validaciones.Mes}}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                    *ngIf="c">
                    <mat-label>{{Etiquetas.Mes}}</mat-label>
                    <input readonly [value]="c.mes" type="text" matInput>

                </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.CuotaCant}}</mat-label>

                        <input type="text" appThreeDigitDecimaNumber matInput formControlName="cuotaCant">
                        <button type="button" matSuffix mat-icon-button (click)="clearInput('cuotaCant')"></button>
                        <mat-error *ngIf="!form.controls['cuotaCant'].valid && form.get('cuotaCant').touched">
                            {{Validaciones.CuotaCant}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="!isInRole('CONSULTOR')" (click)="guardar()" [disabled]="form.invalid" mat-flat-button
        color="accent">Guardar</button>
    <button mat-dialog-close *ngIf="isInRole('CONSULTOR')" mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>